<template>
	<div id="app">
		<navbar @theme-changed="changeTheme" :mode="this.mode"></navbar>
		<router-view :mode="this.mode"/>
		<img id="chad-glory" src="@/assets/landscape.png" alt="Chad in all his glory">
	</div>
</template>

<script>
import Navbar from "@/components/reusables/Navbar";

export default {
	name: 'App',
	components: {
		'navbar': Navbar
	},
	data: function() {
		return {
			mode: 'light'
		}
	},
	methods: {
		changeTheme() {
			if (this.mode === 'light') {
				document.body.style.backgroundColor="#121212";
				this.mode = 'dark';
			}
			else {
				document.body.style.backgroundColor="white";
				this.mode = 'light';
			}
		}
	}
}
</script>

<style lang="less">
	@import "../node_modules/uikit/src/less/uikit.less";
	@import "../node_modules/uikit/src/less/uikit.theme.less";

	#chad-glory {
		width: 100%;
		object-fit: cover;
	}
</style>
